import PropTypes from "prop-types";
import { memo } from "react";
import LuggageSummary from "app/pages/Booking/Quotation/Flight/LuggageSummary/LuggageSummary";

import "./MyFlightDetail.scss";
import Itinerary from "app/pages/.shared/Itinerary";

const MyFlightDetail = ({
	flight = {},
	luggageMaxCount = 0,
	lugaggeCount,
	maxWeightPerCheckedBaggage,
	flightOptions = {},
}) => {
	return (
		<div className="my-flight-detail">
			<div className="itinerary">
				<Itinerary
					inbound={flight.inbound}
					outbound={flight.outbound}
					disableDetails={true}
					displayRouteDetails={true}
					transportationType={flight?.type}
				/>
			</div>

			<LuggageSummary
				luggageMaxCount={luggageMaxCount}
				flight={flight}
				flightOptions={flightOptions}
				bookingLuggageCount={lugaggeCount}
				hideAddLuggageButton
				transportationType={flight.type}
				maxWeightPerCheckedBaggage={maxWeightPerCheckedBaggage}
			/>
		</div>
	);
};

MyFlightDetail.propTypes = {
	flight: PropTypes.object,
	luggageMaxCount: PropTypes.number,
	lugaggeCount: PropTypes.number,
	flightOptions: PropTypes.object,
	maxWeightPerCheckedBaggage: PropTypes.number,
};

export default memo(MyFlightDetail);
